export default function hasWindow(): boolean {
	return typeof window === "object";
}
